import { Button } from '@mui/material'
import AlphabetGrid from '../AlphabetGrid';
import { useState } from 'react';
import { randomStrings, stringKeys } from '../constData'
import CustomButton from '../CustomButton';

const VernamCipherExercise = () => {
    const [showAnsButton, setShowAnsButton] = useState(false);
    const [showCorrectAns, setShowCorrectAns] = useState(false);

    const generateString = () => {
        var index = Math.floor(Math.random() * (29 - 0 + 1) + 0);
        return randomStrings[index];
    }

    const generateOriginalKey = () => {
        var index = Math.floor(Math.random() * (49 - 0 + 1) + 0);
        return stringKeys[index];
    }

    function handleStringGenerate() {
        var string = generateString();
        document.getElementById("plaintext").value = string.replace(/\s/g, "");
        console.log("We Generated a String! : ", string);
    }

    function handleKeyGenerate() {
        var key = generateOriginalKey();
        document.getElementById("key").value = key;
        console.log("We Generated a Key! : ", key);
    }

    function generateKey(length, key) {
        var count = 0;
        var finalKey = "";
        key = key.toUpperCase()
        while (count < length) {
            var i = count % (key.length);
            finalKey += key[i]
            count++;
        }
        finalKey = finalKey.toUpperCase();
        console.log("Final Key : ", finalKey);
        return finalKey;
    }

    const encrypt = async (text, s) => {
        const textLength = text.length;
        const finalKey = generateKey(textLength, s)
        let encryptedText = '';
        for (let i = 0; i < textLength; i++) {
            var keyP = (finalKey[i].charCodeAt(0) - 65) % 26;
            // const charCode = (text.charCodeAt(i) - 65) ^ (finalKey.charCodeAt(i) - 65);
            var currentPlain = text[i];
            var currentCipher = String.fromCharCode((currentPlain.charCodeAt(0) + keyP - 65) % 26 + 65);
            encryptedText += currentCipher;
        }
        return encryptedText;
    }

    function handleSubmit(e) {
        e.preventDefault();

        // Read the form data
        const form = e.target;
        const formData = new FormData(form);
        const formJson = Object.fromEntries(formData.entries());
        console.log(formJson);

        setShowCorrectAns(false);

        var res = encrypt(formData.get("plaintext").toUpperCase(), formData.get("key")).then((val1) => {
            var val2 = formData.get("answer").toUpperCase();
            console.log(val1)
            console.log(val2)
            document.getElementById("correctAns").innerHTML = val1;

            if (val1 === val2) {
                document.getElementById("result").innerHTML = "Correct Answer!";
                document.getElementById("result").style.color = "green";
                console.log("Correct Answer!");
                setShowAnsButton(false);
                setShowCorrectAns(false);
            } else {
                document.getElementById("result").innerHTML = "Wrong Answer!";
                document.getElementById("result").style.color = "red";
                console.log("Wrong Answer!");
                setShowAnsButton(true);
            }

        })
    }

    function showAns() {
        setShowCorrectAns(true);
    }

    return (
        <>
            <form method="post" onSubmit={handleSubmit}>
                <label>
                    Plain Text (only alphabets, without spaces):
                    <input pattern="[a-zA-Z]+" style={{ textTransform: "uppercase" }} required={true} name="plaintext" id='plaintext' />
                    <CustomButton onClick={handleStringGenerate} isSmall={true}>Generate</CustomButton>
                    {/* <Button variant="contained" type='button' size='small' onClick={handleStringGenerate} style={{marginLeft:20}}>Generate</Button> */}
                </label>
                <br />
                <br />
                <label>
                    Key (only alphabets, without spaces):
                    <input name="key" required={true} pattern="[a-zA-Z]+" style={{ textTransform: "uppercase" }} id='key' />
                    <CustomButton onClick={handleKeyGenerate} isSmall={true}>Generate</CustomButton>
                    {/* <Button variant="contained" type='button' size='small' onClick={handleKeyGenerate} style={{ marginLeft: 20 }}>Generate</Button> */}
                </label>
                <br />
                <br />

                <label>
                    Your Answer:
                    <input pattern="[a-zA-Z]+" required={true} style={{ textTransform: "uppercase" }} name="answer" id='answer' />
                </label>
                <br />
                <br />

                <CustomButton type="submit" isSmall={true} beforeHover={"#54B435"} afterHover={"#379237"}>Check Answer</CustomButton>
                {/* <Button variant="contained" type='submit' size='medium' style={{ backgroundColor: "green" }}>Check Answer</Button> */}

            </form>
            <br />
            <p id='result' style={{ fontSize: 20, fontWeight: "bold", display: "inline" }}></p>
            <CustomButton onClick={showAns} display={showAnsButton ? "inline" : "none"} isSmall={true} beforeHover={"#FF204E"} afterHover={"#E72929"}>Show Answer</CustomButton>
            {/* <Button variant="contained" type='button' size='small' style={{ display: showAnsButton ? "inline" : "none", backgroundColor: "red" }} onClick={showAns}> Show Answer </Button> */}
            <p id='correctAns' style={{ fontSize: 18, fontWeight: "bold", display: showCorrectAns ? "block" : "none" }}></p>
        </>
    )
}

export default VernamCipherExercise